import Api from "@src/api";
export const UseFulLifeApi= {
  getList(params) {
    return Api().get("UsefulLifeMaster/Search",{params});
  },
  getUsefulLifeMasterById(id) {
    return Api().get("UsefulLifeMaster/detail/" + id);
  },
  updateUsefulLifeMaster(data) {
    return Api().put("UsefulLifeMaster", data);
  },
  createUsefulLifeMaster(data) {
    return Api().post("UsefulLifeMaster", data);
  },
  deleteUsefulLifeMaster(id) {
    return Api().delete("UsefulLifeMaster/" + id);
  },
};
